import React from 'react';

// DEPENDENCIES
import clsx from 'clsx';
import AutoSizer from 'react-virtualized-auto-sizer';

// LOCAL COMPONENTS
import ListVirtualized from './layout/ListVirtualized';

// LOCAL VARIABLES
const ROW_HEIGHT = 44;

export default function MobileList({
  autoSizeHeight = true, //
  className,
  ...props
}) {
  return (
    <div className={clsx('flex-grow-1 large', className)}>
      <AutoSizer disableWidth disableHeight={!autoSizeHeight}>
        {({ height }) => (
          <ListVirtualized
            {...props} //
            height={height}
            rowHeight={ROW_HEIGHT}
          />
        )}
      </AutoSizer>
    </div>
  );
}
